import { render, staticRenderFns } from "./CreatorLivestreamInteractionItem.vue?vue&type=template&id=12e067a0&scoped=true&"
import script from "./CreatorLivestreamInteractionItem.vue?vue&type=script&lang=js&"
export * from "./CreatorLivestreamInteractionItem.vue?vue&type=script&lang=js&"
import style0 from "./CreatorLivestreamInteractionItem.vue?vue&type=style&index=0&id=12e067a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e067a0",
  null
  
)

export default component.exports